// extracted by mini-css-extract-plugin
module.exports = {"connectWithUs":"styles_connectWithUs__3Dsmx","socialMediaLogoContainer":"styles_socialMediaLogoContainer__1TOFj"};